import { Link } from "react-router-dom";

export interface BreadcrumbRoute {
    name: string;
    path?: string;
}

/**
 * 旧 Vue breadcrumb 的 React 对应物。
 * 路径为空时只展示文字；分隔符使用 Vue 组件相同的 iconfont 字形。
 */
export function Breadcrumb({ routes }: { routes: BreadcrumbRoute[] }) {
    return (
        <nav aria-label="面包屑" className="zh-breadcrumb">
            {routes.map((route, index) => (
                <span className="zh-breadcrumb__item" key={`${route.name}-${index}`}>
                    {route.path ? <Link to={route.path}>{route.name}</Link> : <span>{route.name}</span>}
                    {index < routes.length - 1 ? <i aria-hidden="true" className="zh-breadcrumb__separator" /> : null}
                </span>
            ))}
        </nav>
    );
}
